import { Box, IconButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import React, { useCallback, useState } from 'react';
import MessageToast from '../MessageToast';
import { StyledHeading } from '../styles/styles';
import CashflowReportsExpanded from './CashflowReportsExpanded';
import { useCashflowReportData } from './useCashflowReportData';
import type FundOpportunity from '../../models/FundOpportunity';

export interface CashflowReportsSectionProps {
  fundOpportunity: FundOpportunity;
  onReportsChanged?: () => void;
}
type ToastType = 'error' | 'warning' | 'info' | 'success';

export default function CashflowReportsSection({
  fundOpportunity,
  onReportsChanged,
}: CashflowReportsSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [toastType, setToastType] = useState<ToastType | null>(null);
  const showToast = useCallback((message: string, type: ToastType) => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => {
      setToastMessage(null);
      setToastType(null);
    }, 5000);
  }, []);
  const reportData = useCashflowReportData(fundOpportunity.id, showToast);
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          mt: 3,
          mb: '18px',
          cursor: 'pointer',
        }}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <StyledHeading headerVariant="subheading" reduceBottomPadding sx={{ m: 0, p: 0 }}>
          Cashflow Reports
        </StyledHeading>
        <IconButton size="small">
          {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
      </Box>
      {expanded && (
        <>
          <CashflowReportsExpanded
            {...reportData}
            fundOpportunity={fundOpportunity}
            onReportsChanged={onReportsChanged}
            showToast={showToast}
          />
          <MessageToast
            message={toastMessage ?? ''}
            type={toastType ?? 'info'}
            open={!!toastMessage}
            onClose={() => {
              setToastMessage(null);
              setToastType(null);
            }}
            autoHideDuration={5000}
          />
        </>
      )}
    </Box>
  );
}
